import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import FindItemResponseMessage from 'owa-service/lib/contract/FindItemResponseMessage';
import MailFolderTableQuery from 'mini-mail-list-store/lib/store/schema/MailFolderTableQuery';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { loadInitialConversationFromServer } from './loadInitialConversationFromServer';
import { loadInitialItemFromServer } from './loadInitialItemFromServer';
import { MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD } from './TableLoadingConstants';
import { mergeRowResponseFromTop } from 'mini-mail-list-response-processor';
import { trace } from 'owa-trace';

export let onLoadInitialRowsSucceeded = action('onLoadInitialRowsSucceeded')(
    function onLoadInitialRowsSucceeded(
        tableView: TableView,
        responseMessage: FindConversationResponseMessage | FindItemResponseMessage
    ) {
        // If SearchFolderId is returned in response, set it on the tableView
        if (responseMessage.SearchFolderId) {
            tableView.serverFolderId = responseMessage.SearchFolderId.Id;
        }

        switch (tableView.tableQuery.listViewType) {
            case ReactListViewType.Conversation:
                const {
                    Conversations,
                    TotalConversationsInView,
                } = responseMessage as FindConversationResponseMessage;
                mergeRowResponseFromTop(Conversations, tableView, TotalConversationsInView);
                break;

            case ReactListViewType.Message:
                const {
                    Items,
                    TotalItemsInView,
                } = (responseMessage as FindItemResponseMessage).RootFolder;
                mergeRowResponseFromTop(Items, tableView, TotalItemsInView);
                break;
        }
        // Set the loaded index to max allowed on initial table load
        tableView.currentLoadedIndex = Math.min(
            MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD,
            tableView.itemIds.length
        );
    }
);

/**
 * @param tableView to load rows in
 * @param isTablePrefetched indicates if the table is prefetched
 * @return a promise that resolves when the load table from server has completed
 */
export default action('loadInitialRowsFromServer')(function loadInitialRowsFromServer(
    tableView: TableView,
    isTablePrefetched: boolean
): Promise<void> {
    tableView.isLoading = true;
    tableView.hasErrorLoadingTable = false;
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            return loadInitialConversationFromServer(mailTableQuery, tableView, isTablePrefetched);

        case ReactListViewType.Message:
            return loadInitialItemFromServer(mailTableQuery, tableView, isTablePrefetched);

        default:
            trace.warn('listViewType: ' + tableView.tableQuery.listViewType + ' is not supported.');
            return Promise.resolve();
    }
});
